const InfoTab = ({ company }) => {
  const formatAddress = (address) => {
    if (!address) return "-";

    const parts = [
      address.address_1,
      address.address_2,
      address.address_3,
      address.city,
      address.county,
      address.country,
      address.postcode,
    ];

    const filtered = parts.filter((p) => p && p.trim() !== "");

    return filtered.length ? filtered.join(", ") : "-";
  };

  return (
    <div className="space-y-1 text-sm p-6">
       <Info label="Name" value={company.name} />
       <Info label="Registration Number" value={company.reg_no} />
       <Info label="VAT Number" value={company.vat_no} />
       <Info label="ID" value={company.company_id} />
       <Info label="EUID" value={company.euid} />
       <Info label="Accountant Name" value={company.accountant_name} />
       <Info label="Accountant Phone" value={company.accountant_phone} />
       <Info label="Address" value={formatAddress(company.address)} />
    </div>
  );
};

const Info = ({ label, value }) => (
  <div className="mb-4">
    <p className="text-slate-400">{label}</p>
    <p className="text-white mb-2">{value || "-"}</p>
  </div>
);

export default InfoTab;
